module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._t("default")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94b1fa96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/outputs/ErrorDisplay.vue
// module id = 671
// module chunks = 5